import { render, staticRenderFns } from "./customer-case-mob-imgs.vue?vue&type=template&id=22e63740&scoped=true"
import script from "./customer-case-mob-imgs.vue?vue&type=script&lang=js"
export * from "./customer-case-mob-imgs.vue?vue&type=script&lang=js"
import style0 from "./customer-case-mob-imgs.vue?vue&type=style&index=0&id=22e63740&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e63740",
  null
  
)

export default component.exports